import React from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

const RPM = [1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 5500, 6000, 6500];
const SHAPE = [0.18, 0.30, 0.44, 0.58, 0.71, 0.82, 0.91, 0.97, 1.0, 0.99, 0.94, 0.85];

export const DynoChart = ({ baseHp = 0, gainHp = 0, baseNm = 0, gainNm = 0 }) => {
  const tunedHp = baseHp + gainHp;
  const data = RPM.map((rpm, i) => ({
    rpm,
    Origine: Math.round(baseHp * SHAPE[i]),
    "Stage 1": Math.round(tunedHp * SHAPE[i]),
  }));

  const stats = [
    ["Puissance", baseHp, tunedHp, "ch", "#00E5FF"],
    ["Couple", baseNm, baseNm + gainNm, "Nm", "#C8102E"],
  ];

  return (
    <div data-testid="dyno-chart">
      <div className="flex flex-wrap gap-3 mb-5">
        {stats.map(([lbl, b, t, u, c]) => (
          <div key={lbl} className="flex-1 min-w-[150px] glass rounded-sm px-4 py-3">
            <div className="font-mono text-[9px] uppercase tracking-widest text-zinc-500">{lbl}</div>
            <div className="flex items-baseline gap-2 mt-1">
              <span className="font-mono text-sm text-zinc-500 line-through">{b}{u}</span>
              <span className="font-display text-2xl font-bold" style={{ color: c }}>{t}{u}</span>
              <span className="font-mono text-[11px] font-bold text-signal-success">+{t - b}</span>
            </div>
          </div>
        ))}
      </div>
      <div style={{ width: "100%", height: 240 }}>
        <ResponsiveContainer>
          <AreaChart data={data} margin={{ top: 8, right: 8, left: -16, bottom: 0 }}>
            <defs>
              <linearGradient id="gTuned" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#00E5FF" stopOpacity={0.45} />
                <stop offset="100%" stopColor="#00E5FF" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="gStock" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#71717a" stopOpacity={0.22} />
                <stop offset="100%" stopColor="#71717a" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false} />
            <XAxis dataKey="rpm" tick={{ fill: "#9aa3b2", fontSize: 10, fontFamily: "monospace" }} tickLine={false} axisLine={false} />
            <YAxis tick={{ fill: "#9aa3b2", fontSize: 10, fontFamily: "monospace" }} tickLine={false} axisLine={false} width={42} unit=" ch" />
            <Tooltip
              contentStyle={{ background: "#111111", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, fontSize: 12 }}
              labelStyle={{ color: "#a1a1aa" }}
              labelFormatter={(v) => `${v} tr/min`}
            />
            <Legend wrapperStyle={{ fontSize: 11, fontFamily: "monospace", textTransform: "uppercase" }} />
            <Area type="monotone" dataKey="Origine" stroke="#a1a1aa" strokeWidth={2} fill="url(#gStock)" strokeDasharray="4 3" animationDuration={900} />
            <Area type="monotone" dataKey="Stage 1" stroke="#00E5FF" strokeWidth={2.5} fill="url(#gTuned)" animationDuration={1300} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
